module.exports = __webpack_public_path__ + "img/kv-banner-tc.72a7099e.png";